import React, { Component } from 'react';
import '../myutils';
import {
    translate,
} from 'react-admin'; 
import BookIcon from '@material-ui/icons/Book'; 
import ContentPaste from '@material-ui/icons/ContentPaste';
import { configAPI } from '../config'
import { push as pushAction } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { refreshView as refreshViewAction } from 'ra-core';

export const TemplateIcon = BookIcon;

class PasteFile extends Component {

    state = {
        open: false,
    };
    constructor(props) {
        super(props);
        this.state = {
            record: false
        }
    }

    handleClickPaste = (e, record) => {
        e.stopPropagation();
        const {  push } = this.props;
        var whats, target, copiedFile;
        var data = new FormData();

        if (sessionStorage.action === 'move') {
            target = record.path;
            data.append("token", sessionStorage.B.encodeDecode());
            data.append("action", "move");
            data.append("target", target.replace('ivr2:', 'ivr2:/'));
            copiedFile = sessionStorage.getItem('copiedFile');
            if (copiedFile.includes('//..//')) whats = copiedFile.split('//..//');
            else whats = [copiedFile,''];
            whats.pop();
            whats.forEach((what, index) => {
                data.append("what" + index, what.replace('ivr2:', 'ivr2:/'));
            });

            return fetch(configAPI.api.prod + 'FileAction', {
                method: "POST",
                body: data
            }).then((resp) => {

                if (resp.ok) {
                    sessionStorage.removeItem('copiedFile');
                    sessionStorage.setItem('action', 'copy');
                    const {refreshView} = this.props;
                    refreshView();
                    push('/IVR?filter=' + sessionStorage.Filter);

                }
            })
        }
        else if (sessionStorage.action === 'copy') {
            target = record.path;
            data.append("token", sessionStorage.B.encodeDecode());
            data.append("action", "copy");
            data.append("target", target.replace('ivr2:', 'ivr2:/'));
            copiedFile = sessionStorage.getItem('copiedFile');
            if (copiedFile.includes('//..//')) whats=copiedFile.split('//..//');
            else whats = [copiedFile,''];
            whats.pop();
            whats.forEach((what, index) => {
                data.append("what" + index, what);
            });

            return fetch(configAPI.api.prod + 'FileAction', {
                method: "POST",
                body: data
            }).then((resp) => {

                if (resp.ok) {
                        const {refreshView} = this.props;
                        refreshView();
                    push('/IVR?filter=' + sessionStorage.Filter);

                }
            })
        }
    };

    render() {
        const { translate, record } = this.props;
        return (
            <Tooltip title={translate(`trans.paste`)}>
                <IconButton onClick={(e) => this.handleClickPaste(e, record)}>
                    <ContentPaste />
                </IconButton>
            </Tooltip>
        );
    }
}

PasteFile.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

const enhance = connect(
    null,
    { refreshView: refreshViewAction }
  );


export default enhance(connect(null, {
    push: pushAction,
})(translate(PasteFile)));
